module.exports = __webpack_public_path__ + "img/img_26.9363721c.png";